import { useContext } from 'react';
import { createContext } from 'react';

import { GiftDescriptionProps } from '../@types/GiftDescriptionProps';

export const GiftDescriptionContext = createContext<GiftDescriptionProps>({} as GiftDescriptionProps);

GiftDescriptionContext.displayName = 'GiftDescription';

const GiftDescriptionProvider = (props: GiftDescriptionProps) => (
	<GiftDescriptionContext.Provider value={props}>{props.children}</GiftDescriptionContext.Provider>
);

export const useGiftDescription = () => {
	const context = useContext(GiftDescriptionContext);

	return context;
};

export default GiftDescriptionProvider;
